export default __webpack_public_path__ + "static/media/redflag_system.4b86ef4c.jpg";